<template>
    <button
        :disabled="disabled"
        :class="[
            'cag-button',
            {
                outlined,
                error,
                success,
                'no-border': noBorder,
            },
        ]"
        :type="type"
    >
        <slot />
    </button>
</template>

<script>
export default {
    name: 'CagButton',
    props: {
        outlined: {
            type: Boolean,
            required: false,
            default: false,
        },
        noBorder: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false,
        },
        success: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        type: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style lang="scss" scoped>
.cag-button {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 2rem;
    background-color: $color-highlight;
    border: 1px solid $color-highlight;
    border-radius: 0.5rem;
    box-shadow: $shadow-2;
    color: $color-font-light;
    text-transform: uppercase;
    font-weight: $font-weight-bold;
    font-size: 1rem;
    transition: $transition-fast;
    & > * + * {
        margin-left: 0.5rem;
    }
    .icon--button {
        flex: none;
    }
    &:focus,
    &:hover {
        outline: none;
        background-color: lighten($color-highlight, 5%);
        border-color: lighten($color-highlight, 5%);
        box-shadow: $shadow-4;
    }
    &.success {
        background-color: $color-success;
        border-color: $color-success;
        // color: $color-font-dark;
        &:focus,
        &:hover {
            background-color: lighten($color-success, 5%);
            border-color: lighten($color-success, 5%);
        }
    }
    &.error {
        background-color: $color-error;
        border-color: $color-error;
        &:focus,
        &:hover {
            background-color: lighten($color-error, 7%);
            border-color: lighten($color-error, 7%);
        }
    }
    &:disabled {
        cursor: not-allowed;
        background-color: $color-gray-light;
        border-color: $color-gray-light;
        box-shadow: none;
        &:focus,
        &:hover {
            background-color: $color-gray-light;
            border-color: $color-gray-light;
        }
    }
}
.outlined {
    background-color: transparent;
    color: $color-highlight;
    border: 1px solid $color-highlight;
    &:hover,
    &:focus {
        background-color: $color-blue-light;
    }
    &.success {
        background-color: transparent;
        color: $color-success;
        border-color: $color-success;
        &:focus,
        &:hover {
            background-color: $color-green-light;
            border-color: $color-success;
        }
    }
    &.error {
        background-color: transparent;
        color: $color-error;
        border-color: $color-error;
        &:focus,
        &:hover {
            background-color: $color-red-light;
            border-color: $color-error;
        }
    }
    &:disabled {
        background-color: transparent;
        color: $color-gray-light;
        border-color: $color-gray-light;
        &:focus,
        &:hover {
            background-color: transparent;
            border-color: $color-gray-light;
        }
    }
}
.no-border {
    background-color: transparent;
    color: $color-highlight;
    border: 1px solid transparent;
    box-shadow: none;
    &:hover,
    &:focus {
        background-color: $color-blue-light;
    }
    &.success {
        background-color: transparent;
        color: $color-success;
        border-color: transparent;
        &:focus,
        &:hover {
            background-color: $color-green-light;
            border-color: transparent;
        }
    }
    &.error {
        background-color: transparent;
        color: $color-error;
        border-color: transparent;
        &:focus,
        &:hover {
            background-color: $color-red-light;
            border-color: transparent;
        }
    }
    &:disabled {
        background-color: transparent;
        color: $color-gray-light;
        border-color: transparent;
        &:focus,
        &:hover {
            background-color: transparent;
            border-color: transparent;
        }
    }
}
</style>
